// Brand lockup: subtle four-point star inside a thin orbit + SACREDSPACE wordmark.
// Swap this component for an official logo later — it is used on every screen.

export function StarGlyph({ className = "h-4 w-4" }) {
    return (
        <svg
            viewBox="0 0 32 32"
            className={className}
            aria-hidden="true"
            fill="none"
        >
            <ellipse
                cx="16"
                cy="16"
                rx="13.5"
                ry="5"
                stroke="currentColor"
                strokeWidth="1.1"
                opacity="0.55"
                transform="rotate(-22 16 16)"
            />
            <path
                d="M16 5.5 L17.7 14.3 L26.5 16 L17.7 17.7 L16 26.5 L14.3 17.7 L5.5 16 L14.3 14.3 Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default function Wordmark({ compact = false }) {
    return (
        <span
            data-testid="brand-wordmark"
            className="inline-flex items-center gap-2.5"
        >
            <StarGlyph className="h-4 w-4 text-celestial-gold" />
            <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-slate-200 sm:text-xs">
                SacredSpace
            </span>
            {!compact && (
                <span className="hidden font-mono text-[10px] uppercase tracking-[0.28em] text-slate-500 md:inline">
                    · Through The Cosmic Lens
                </span>
            )}
        </span>
    );
}
